import React, { useState } from 'react'

const FAQSection = ({ title, faqData }) => {
    const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <>
     <section className="ib-faq-section">
        
         <div className="ib-faq-container">
        <header className="ib-faq-header">
          <span className="ib-faq-label">Common Questions</span>
          <h2 className="ib-faq-title">{title}</h2>
        </header>

        <div className="ib-faq-list">
          {faqData.map((item, index) => (
            <div 
              key={index} 
              className={`ib-faq-item ${activeIndex === index ? 'is-active' : ''}`}
            >
              <button 
                className="ib-faq-question-btn"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
              >
                <span className="ib-faq-question-text">{item.question}</span>
                <div className="ib-faq-icon">
                  <div className="ib-icon-line ib-line-h"></div>
                  <div className="ib-icon-line ib-line-v"></div>
                </div>
              </button>
              <div className="ib-faq-answer-wrapper">
                <div className="ib-faq-answer-content">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  )
}

export default FAQSection
